import { memo } from "react";
import { ListItemText, MenuItem } from "@mui/material";
import { CustomCheckbox } from "../CustomCheckbox";
import { ExportCompany } from "../../../types/apiTypes";

export const ListItem = memo(
  ({
    company,
    isSelected,
    handleChange,
  }: {
    company: ExportCompany;
    isSelected: boolean;
    handleChange: (item: string) => void;
  }) => {
    const { name, is_analyzed, id } = company;
    return (
      <MenuItem
        sx={{
          padding: "4px",
        }}
        value={name}
        onClick={() => handleChange(id)}
        disabled={!is_analyzed}
      >
        <CustomCheckbox checked={isSelected} />
        <ListItemText
          primary={name}
          primaryTypographyProps={{
            sx: {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          }}
        />
      </MenuItem>
    );
  },
);
